import React from "react";

export default function TagGroup({ items = [], onRemove }) {
  return (
    <div className="tag-list" style={styles.group}>
      {items.map((item, index) => (
        <div key={index} style={styles.tag}>
          <span style={styles.text}>{item.title}</span>
          <span 
            style={styles.close}
            onClick={() => onRemove(index)}
          >
            ✕
          </span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  group: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px"
  },
  tag: {
    display: "flex",
    alignItems: "center",
    background: "#1f1f1f",
    color: "#fff",
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "14px",
    fontWeight: "500"
  },
  text: {
    marginRight: "8px"
  },
  close: {
    cursor: "pointer",
    fontSize: "14px",
    opacity: 0.8,
    userSelect: "none"
  }
};